<template>
  <div>
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/logo-linkedin.svg"
      alt="linkedin"
      width="28"
      height="28"
      v-if="icon == 'linkedin'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/logo-facebook.svg"
      alt="facebook"
      width="15"
      height="29"
      v-if="icon == 'facebook'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/logo-twitter.svg"
      alt="twitter"
      width="25"
      height="25"
      v-if="icon == 'twitter'"
    />
    <img
      loading="lazy"
      class="flex mx-4 md:mx-6"
      src="~/assets/images/logo-youtube.svg"
      alt="youtube"
      width="32"
      height="22"
      v-if="icon == 'youtube'"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  icon: String,
});
</script>


<style scoped>
</style>
